import { FILTER_LABEL } from "../../../constants";

export const messageStatusEnumns = {
  READ: 6,
  UNREAD: 7,
  RESOLVED: 3,
};

export const conversationStatusEnums = {
  POSITIVE: 1,
  PASSIVE: 2,
  NEGATIVE: 3,
};

export const conversationFilters = [
  { id: 1, name: FILTER_LABEL.ALL, value: "", className: "all-filter" },
  {
    id: 2,
    name: "Positive",
    value: "conversationStatus == 1",
    className: "positive-filter",
  },
  {
    id: 3,
    name: "Passive",
    value: "conversationStatus == 2",
    className: "passive-filter",
  },
  {
    name: "Negative",
    value: "conversationStatus == 3",
    className: "negative-filter",
  },
];

export const messageStatusCssClasses = {
  RESOLVED_LABEL: "resolved-label",
};

export const previousConversationStatusClasses = {
  RESOLVED_LABEL: "resolved-status",
};

export const inboxReduxConstants = {
  SEND_MESSAGE: "SEND_MESSAGE",
  GET_SURVEY_USERS: "GET_SURVEY_USERS",
  UPDATE_CUSTOMER_CONVERSATION_MESSAGES:
    "UPDATE_CUSTOMER_CONVERSATION_MESSAGES",
  RESET_CONVERSATION: "RESET_CONVERSATION",
  RESET_AI_RESPONSE: "RESET_AI_RESPONSE",
  SAVE_INTERNAL_NOTES: "SAVE_INTERNAL_NOTES",
  GENERATE_AI_RESPONSE: "GENERATE_AI_RESPONSE",
  DELETE_INTERNAL_NOTE: "DELETE_INTERNAL_NOTE",
  GET_ALL_CONVERSATIONS: "GET_ALL_CONVERSATIONS",
  GET_CUSTOMER_INSIGHTS: "GET_CUSTOMER_INSIGHTS",
  RESET_ALL_CONVERSATIONS: "RESET_ALL_CONVERSATIONS",
  UPDATE_ALL_CONVERSATIONS: "UPDATE_ALL_CONVERSATIONS",
  GET_CONVERSATION_MESSAGES: "GET_CONVERSATION_MESSAGES",
  GET_PREVIOUS_INTERNAL_NOTES: "GET_PREVIOUS_INTERNAL_NOTES",
  GET_PREVIEW_CUSTOMER_SURVEY: "GET_PREVIEW_CUSTOMER_SURVEY",
  UPDATE_CONVERSATION_MESSAGES: "UPDATE_CONVERSATION_MESSAGES",
  GET_CONVERSATION_ORDER_DETAILS: "GET_CONVERSATION_ORDER_DETAILS",
  GET_PREVIOUS_CONVERSATION_DATES: "GET_PREVIOUS_CONVERSATION_DATES",
  GET_CUSTOMER_CONVERSATION_BY_DATE: "GET_CUSTOMER_CONVERSATION_BY_DATE",
  RESET_PREVIOUS_CONVERSATION_DATES: "RESET_PREVIOUS_CONVERSATION_DATES",
  GET_CONVERSATION_BY_CONVERSATION_ID: "GET_CONVERSATION_BY_CONVERSATION_ID",
  UPDATE_CUSTOMER_CONVERSATION_STATUS: "UPDATE_CUSTOMER_CONVERSATION_STATUS",
};

export const filterConstants = {
  CUSTOMER_NAME: "CustomerName",
  CUSTOMER_EMAIL: "CustomerEmail",
  CUSTOMER_PHONE: "CustomerPhone",
  ORDER_ID: "OrderId",
  POSITIVE: "Positive",
  NEGATIVE: "Negative",
};

export const advanceSearchfilters = [
  {
    id: 1,
    name: "Name",
    value: filterConstants.CUSTOMER_NAME,
  },
  {
    id: 2,
    name: "Email",
    value: filterConstants.CUSTOMER_EMAIL,
  },
  {
    id: 3,
    name: "Phone",
    value: filterConstants.CUSTOMER_PHONE,
  },
];

export const signalRConstants = {
  connectedState: "Connected",
  disconnectedState: "Disconnected",
  invalidBrandIdError: "Invalid brand Id",
  userUpdatedConnectionKey: "UserUpdated",
  userDeletedConnectionKey: "UserDeleted",
  sendMessageconnectionKey: "SendMessage",
  brandFeatureUpdate: "FeatureUpdated",
  storeFeatureUpdate: "StoreFeatureUpdated",
  connectionUrl: `/messageBoardHub?userId=`,
  receiveMessageconnectionKey: "ReceiveMessage",
  addToBrandGroupConnectionKey: "AddToBrandGroup",
  updateConversationConnectionKey: "UpdateConversation",
  conversationUpdatedConnectionKey: "ConversationUpdated",
  removeFromBrandGroupConnectionKey: "RemoveFromBrandGroup",
  receiveNewConversationConnectionKey: "CreateNewCustomerConversation",
};

export const SIGNALR_TIMINGS = {
  LOGOUT_DELAY_MS: 500,
  USER_PROFILE_TOAST_DURATION_MS: 5000,
  FEATURE_UPDATE_TOAST_DURATION_MS: 4000,
};

export const SIGNALR_FEATURE_DISPLAY = {
  ENABLED: "enabled",
  DISABLED: "disabled",
  IN_STORE_LABEL: "In Store",
  NPS_FIRST_LABEL: "NPS First",
};

export const inboxPageConstants = {
  ASCENDING: "asc",
  DESCENDING: "desc",
  MYSELF_TAG: "(Myself)",
  MAXIMUM_UNREAD_COUNT: 99,
  INTERNAL_NOTES: "internalNotes",
  UPDATED_NOTE_ID: "updatedNoteId",
  MAXIMUM_UNREAD_COUNT_LABEL: "99+",
  DEFAULT_FILE_SIZE_IN_BYTES: 5242880,
  UNREAD_MESSAGE_DOT_COLOR: "#046eef",
  REPLACE_USERNAME_FROM_AI_RESPONSE: "[UserName]",
  /** Max menu width for advance-search select. */
  SEARCH_SELECT_MAX_MENU_WIDTH: 50,
  /** Readonly survey / notes textarea rows. */
  READONLY_TEXTAREA_ROWS: 3,
};

/** Status emoji icon size (conversation list / previous conversations). */
export const CONVERSATION_STATUS_ICON_SIZE = 20;

/** ThreeDots loading spinner dimensions used in inbox side panels. */
export const LOADING_SPINNER_SIZE = 50;

/** Bootstrap Spinner `size` prop values. */
export const BOOTSTRAP_SPINNER_SIZE = {
  SM: "sm",
};

/** Unread message indicator (GoDotFill) size. */
export const UNREAD_DOT_ICON_SIZE = 15;

/** Refresh control icon / GIF size in conversation sub-filter. */
export const REFRESH_ICON_SIZE = 18;

/** Accordion header icons in customer detail sidebar. */
export const ACCORDION_HEADER_ICON_SIZE = 20;

/** Composer action icons (emoji, attach, send). */
export const INPUT_FIELD_ICON_SIZE = 24;

/** Star rating icon size in inbox survey preview. */
export const SURVEY_STAR_ICON_SIZE = 30;

export const icons = [
  { id: 1, name: "thumbs up", icon: "👍" },
  { id: 2, name: "thumbs down", icon: "👎" },
  { id: 3, name: "clapping hands", icon: "👏" },
  { id: 4, name: "raising hands", icon: "🙌" },
  { id: 5, name: "ok hand", icon: "👌" },
  { id: 6, name: "victory hand", icon: "✌️" },
  { id: 7, name: "peace hand", icon: "✌️" },
  { id: 8, name: "waving hand", icon: "👋" },
  { id: 9, name: "writing hand", icon: "✍️" },
  { id: 10, name: "party popper", icon: "🎉" },
  { id: 11, name: "fire", icon: "🔥" },
  { id: 12, name: "100", icon: "💯" },
  { id: 13, name: "sparkles", icon: "✨" },
  { id: 14, name: "heart eyes", icon: "😍" },
  { id: 15, name: "rolling on the floor laughing", icon: "🤣" },
  { id: 16, name: "thinking face", icon: "🤔" },
  { id: 17, name: "red heart", icon: "❤️" },
  { id: 18, name: "yellow heart", icon: "💛" },
  { id: 19, name: "green heart", icon: "💚" },
  { id: 20, name: "blue heart", icon: "💙" },
  { id: 21, name: "purple heart", icon: "💜" },
  { id: 22, name: "heart with ribbon", icon: "💝" },
  { id: 23, name: "heart decoration", icon: "💟" },
  { id: 24, name: "home", icon: "🏠" },
  { id: 25, name: "search", icon: "🔍" },
  { id: 26, name: "settings", icon: "⚙️" },
  { id: 27, name: "user", icon: "👤" },
  { id: 28, name: "heart", icon: "❤️" },
  { id: 29, name: "star", icon: "⭐" },
  { id: 30, name: "chat", icon: "💬" },
  { id: 31, name: "calendar", icon: "📅" },
  { id: 32, name: "mail", icon: "✉️" },
  { id: 33, name: "bell", icon: "🔔" },
  { id: 34, name: "camera", icon: "📷" },
  { id: 35, name: "music", icon: "🎵" },
  { id: 36, name: "video", icon: "🎥" },
  { id: 37, name: "map", icon: "🗺️" },
  { id: 38, name: "bookmark", icon: "🔖" },
  { id: 39, name: "clock", icon: "⏰" },
];

export const customerInfoConstants = {
  NAME: "Name",
  PHONE: "Phone",
  EMAIL: "Email",
  ORDER_NO: "Order No",
  STORE_NAME: "Store Name",
};

export const inboxToConsumerResponseStateName = "inbox-to-consumerResponses";

export const conversationSubFilters = [
  {
    id: 1,
    name: FILTER_LABEL.ALL,
    value: "",
  },
  {
    id: 2,
    name: "Unread",
    value: "(HasUnreadMessages == true OR isNew == true)",
  },
  {
    id: 3,
    name: "Read",
    value: "HasUnreadMessages == false AND isNew == false",
  },
  {
    id: 4,
    name: "Survey Includes Comments",
    value: "HasTextBoxAnswer == true",
  },
  {
    id: 5,
    name: "Conversation Started",
    value: "Message != null",
  },
];

export const assignedUserRole = {
  BRAND_ADMIN: "Brand Admin",
  GROUP_ADMIN: "Group Admin",
  MANAGER_ADMIN: "Manager Admin",
};

export const inboxTabsNames = {
  survey: "survey",
  previousConversation: "previousConversation",
};

export const signalrConnectionStates = {
  DISCONNECTED: { status: "Disconnected", theme: "danger" },
  RECONNECTING: { status: "Reconnecting..", theme: "warning" },
  CONNECTED: { status: "Connected", theme: "success" },
  CONNECTING: {
    theme: "secondary",
    status: "Connecting",
  },
};

export const MAX_CHAR_LIMIT = 30;

export const customerDetailsAccordionsNames = {
  CUSTOMER_INFO: "customer-info",
  CUSTOMER_INSIGHT: "customer-insight",
  SURVEYS: "surveys",
  PREVIOUS_CONVERSATIONS: "previous-conversations",
  INTERNAL_NOTE: "internal Notes",
};

export const defaultOpenAccordions = [
  customerDetailsAccordionsNames.CUSTOMER_INFO,
  customerDetailsAccordionsNames.CUSTOMER_INSIGHT,
  customerDetailsAccordionsNames.SURVEYS,
];

export const customerInsightsConstants = {
  SURVEY_SENT: "Surveys Sent",
  SURVEY_COMPLETED: "Surveys Completed",
  RESPONSE_RATE: "Response Rate",
  AVERAGE_TEANSACTION_RATING: "Average Transaction Rating",
  AVERAGE_SENTIMENT_RATING: "Average Sentiment Rating",
  POSITIVE_RATING: 4.5,
  PASSIVE_RATING: 4,
};
